/**
 * Group adjacent lines into paragraph clusters.
 *
 * A paragraph break is detected when:
 *   - Vertical gap between line bottom and next line top exceeds GAP_RATIO × line height
 *   - OR font height changes substantially (RATIO_THRESHOLD)
 *   - OR the next line is in a different page or column
 *
 * Lines belonging to the same paragraph stay grouped so they can be merged into a
 * single InlineRun sequence by downstream transformers.
 */
const GAP_RATIO = 0.6; // gap > 0.6 × line height → new paragraph
const HEIGHT_RATIO_THRESHOLD = 1.25; // 25% font-size change → new paragraph
export function groupIntoParagraphs(lines) {
    const groups = [];
    let current = [];
    const flush = () => {
        if (current.length === 0)
            return;
        const heights = current.map((l) => l.height).sort((a, b) => a - b);
        const median = heights[Math.floor(heights.length / 2)] ?? current[0].height;
        groups.push({
            page: current[0].page,
            column: current[0].column,
            lines: current.slice(),
            height: median,
        });
        current = [];
    };
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (current.length === 0) {
            current.push(line);
            continue;
        }
        const prev = current[current.length - 1];
        // Different page or column → break.
        if (prev.page !== line.page || prev.column !== line.column) {
            flush();
            current.push(line);
            continue;
        }
        // Vertical gap break.
        const prevBottom = prev.y + prev.height;
        const gap = line.y - prevBottom;
        const lineHeight = Math.max(prev.height, line.height);
        if (gap > lineHeight * GAP_RATIO) {
            flush();
            current.push(line);
            continue;
        }
        // Font height change break.
        const ratio = Math.max(prev.height, line.height) / Math.max(0.1, Math.min(prev.height, line.height));
        if (ratio > HEIGHT_RATIO_THRESHOLD) {
            flush();
            current.push(line);
            continue;
        }
        current.push(line);
    }
    flush();
    return groups;
}
//# sourceMappingURL=paragraphs.js.map